/**
 * Manages the state of the auth forms - login form, register form, forgot password form.
 *
 * Note that the actual authentication status of the user runs on state.user.data
 * which is handled by userReducer.
 */

const defaultAuthState = {
  isValidating: false,
  showSetPasswordModal: false,
  showSetPasswordCloseButton: null,
  isResettingPassword: false,
};

const authReducer = (state = defaultAuthState, action) => {
  switch (action.type) {
    case 'FORGOT_PASSWORD_START':
      return {
        ...state,
        isResettingPassword: true,
      };
    case 'FORGOT_PASSWORD_END':
      return {
        ...state,
        isResettingPassword: false,
      };
    case 'VALIDATE_START':
      return {
        ...state,
        isValidating: true,
      };
    case 'VALIDATE_END':
      return {
        ...state,
        isValidating: false,
      };
    case 'SETPASSWORD_MODAL_SHOW':
      return {
        ...state,
        showSetPasswordModal: true,
        showSetPasswordCloseButton: action.showCloseButton,
      };
    case 'SETPASSWORD_MODAL_HIDE':
      return {
        ...state,
        showSetPasswordModal: false,
        showSetPasswordCloseButton: null,
      };
    case 'SET_USER_DETAILS':
      // Modal is now explicitly triggered by ValidateUser component when needed
      // Don't automatically show modal based on passwordResetPending here
      return state;
    default:
      return state;
  }
};

export default authReducer;
